module.exports = require('./helpers/bundle-url').getBundleURL('adEVu') + "logo-dark.ba5147f0.svg";